import { ComboboxPopover } from '@reach/combobox';
import PropTypes from 'prop-types';
import * as React from 'react';
import warning from 'tiny-warning';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';
import { useInternalDialogConfigContext } from '../../../react/components/modal-dialog/dialog.component.js';
import { ROOT_CLASSNAMES } from '../../../core/constants/globals.js';
import { RenderComp } from '../../../react/components/core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * Enable the combobox dropdown to overflow outside the modal dialog.
   */ inModal: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
/**
 * @deprecated use new `Combobox` and its sub-components instead
 */ const LegacyComboboxPopover = renderWithRef('LegacyComboboxPopover', propTypes, (props, ref)=>{
    const { inModal: ctxInModal, portal: ctxPortal } = useInternalDialogConfigContext();
    const popoverRef = React.useRef(null);
    const { as, component, children, darkMode, inModal } = props;
    const combinedRef = assignRefs(ref, popoverRef);
    const classNames = new Set([
        ROOT_CLASSNAMES.base,
        'swan-legacy-listbox-popover'
    ]);
    if (inModal) classNames.add('swan-legacy-listbox-popover-in-modal');
    const processProps = _object_spread_props(_object_spread({}, props), {
        lightMode: !darkMode,
        inModal: ctxInModal !== null && ctxInModal !== void 0 ? ctxInModal : inModal,
        portal: ctxPortal
    });
    warning(as === undefined && component === undefined, 'props `as` and `component` not supported as ComboboxPopover uses 3rd party lib');
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: ComboboxPopover,
        forwardedRef: combinedRef,
        classNames: classNames,
        props: processProps,
        propKeysToRemove: propKeysToRemove
    }, children);
});
LegacyComboboxPopover.defaultProps = {
    inModal: false
};

export { LegacyComboboxPopover };
